export default "__VITE_ASSET__Cmt7b7_T__"